<template>
  <el-scrollbar wrap-class="scrollbar-wrapper">
    <!-- <div class="home">
      <img :src="homeIcon" @click="$router.push({ path: '/dashboard' })" >
    </div> -->

    <el-menu
      class="left-menu"
      :show-timeout="200"
      :collapse="false"
      mode="vertical"
      text-color="#ffffff"
      active-text-color="#ffffff">
      <div class="cascader-wrapper">
        <Cascader v-model="floor" @change="changeCascader" />
      </div>
      <el-divider></el-divider>
      <template v-for="(item, index) in navList">
        <app-link :to="{path:item.router,query:routerQuery}" :key="index">
          <el-menu-item>
            <menu-item :icon="item.icon" :title="item.title" />
          </el-menu-item>
        </app-link>
      </template>
    </el-menu>
  </el-scrollbar>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import eventHub from '@/utils/eventHub';
import MenuItem from './menu-item.vue';
import AppLink from './app-link.vue';
import { getAllPlaces } from '@/api/place';
import Cascader from './cascader.vue';


export default {
  components: { MenuItem, AppLink, Cascader },
  computed: {
    ...mapGetters(['floorInfo']),
    floorId() {
      return this.$route.query.floor_id;
    },
    placeId() {
      return this.$route.query.place_id;
    },
    vrId() {
      return this.$route.query.vr_id;
    },
  },
  data() {
    return {
      floor: [],
      placeData: [],
      routerQuery: {},
      navList: [
        {
          router: '/map/mapAlign/2d',
          title: 'CAD地图',
          icon: 'plus',
        },
        {
          router: '/map/mapLiveAction/live',
          title: '勘场地图',
          icon: 'plus',
        },
        {
          router: '/map/mapAlign/3d',
          title: 'LEICA地图',
          icon: 'plus',
        },
        {
          router: '/map/mapAlign/cmap',
          title: 'C端地图',
          icon: 'plus',
        },
        {
          router: '/map/gisMapRouter',
          title: 'GIS地图',
          icon: 'plus',
        },
        {
          router: '/map/mapLiveAction/navigation',
          title: '导航实景',
          icon: 'plus',
        },
        {
          router: '/map/mapLabel/poiLabel',
          title: 'POI标注',
          icon: 'plus',
        },
        {
          router: '/map/mapRouter/route',
          title: '路网标注',
          icon: 'plus',
        },
        {
          router: '/map/newMapRouter',
          title: '新路网标注',
          icon: 'plus',
        },
        {
          router: '/map/scopeLabeling',
          title: '范围标注',
          icon: 'plus',
        },
        {
          router: '/map/vrUpdate',
          title: '轻量化VR更新',
          icon: 'plus',
        },
        {
          router: '/map/uploadfile',
          title: '上传文件',
          icon: 'plus',
        },
        {
          router: '/map/leicaAlign',
          title: '莱卡图对齐',
          icon: 'plus',
        },
      ],
      // eslint-disable-next-line global-require
      homeIcon: require('@/assets/image/home.png'),
    };
  },
  created() {
    this.getAllPlaces();
    this.initRouterParams();
  },
  watch: {
    // eslint-disable-next-line func-names
    '$route.params.source': function (val) {

    },
  },
  methods: {
    ...mapActions(['ToggleFloorInfo']),
    async getAllPlaces() {
      const { data } = await getAllPlaces({});
      this.placeData = data;
    },
    initRouterParams() {
      if (this.placeId) this.routerQuery.place_id = this.placeId;
      if (this.floorId) this.routerQuery.floor_id = this.floorId;
      if (this.vrId) this.routerQuery.vr_id = this.vrId;
    },
    changeCascader(val) {
      console.log(val);
      this.ToggleFloorInfo(val);
      if (val[0] && val[0].id) this.routerQuery.place_id = val[0].id;
      if (val[1] && val[1].id) this.routerQuery.floor_id = val[1].id;
      if (val[1]) this.routerQuery.vr_id = val[1].vr_id;
      this.$router.push({ path: '/map/mapAlign/2d', query: this.routerQuery });
    },
  },

};
</script>
<style lang="less" scoped>
.scrollbar-wrapper{
  display:flex;
  flex-direction:column;
  overflow: hidden;
  height: 100%;
}
.left-menu {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 10px;
  box-sizing: border-box;
}
.el-menu-item {
  height: 30px;
  line-height: 30px;
  border-radius: 10px;
  background-color: #292929;
  margin: 6px 0;
  font-size: 14px;
}
::v-deep .router-link-active .el-menu-item {
  background-color: #0884ff !important;
}
.home {
  height: 50px;
  background-color: #3a3a3a;
  display: flex;
  justify-content: center;
  align-items: center;
}
.cascader-wrapper{
  padding: 0px 5px 10px 5px;
  ::v-deep input.el-input__inner{
    background-color: #48484A;
    border-color: #48484A;
    color: #fff;
  }
}
.el-divider--horizontal{
  margin: 0;
}
</style>
